import axios from '../utils/axios';
export const getAvailableJettons = async () => axios.get('user/getAllowJettons');
